/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { Mentions } from 'antd';
import { useSpring, animated } from 'react-spring';

import SendButton from './SendButton';
import Button from '../../../../shared/components/Button/Button';
import FeedDropdownOptions from './FeedDropdownOptions';
import FeedGiphyEmoji from './FeedGiphyEmoji';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import {
  transformPostText,
  imageFlipper,
  urlSnapper,
  pictureSelector,
  userParser,
  createMentionSearchValidator,
  buildSubmissionObject,
  findFeedIndex,
  findCommentIndex,
  findReplyIndex,
  dateCreator,
  editMentionText,
  filterUserMentions,
  extractMentionsFromText,
  replaceMentionsInMessage,
} from '../../helperFunctions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

import useFeed from '../hooks/useFeed';
import {
  openMessageVideo,
  openImageLightbox,
  setIsReplyActivatedRedux,
  setUploadMediaFalse,
  setActiveReduxModal,
  setReportPostInfo,
  setUploadMedia,
  setActiveMediaBarOb,
} from '../../ducks/feedActions';

const DropdownDiv = styled('div')`
  position: absolute;
  margin-left: 400px;
`;

const FeedPostCommentReplyDiv = styled('div')`
  font-size: 12px;
  margin-top: 10px;
`;

const FeedPostReplyContent = styled('div')`
  padding: 8px 0 0px;
  font-size: 12px;
  .reply-author {
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
  }
  .reply-body {
    font-family: 'Nunito Sans', sans-serif;
    padding: 10px 0;
    font-size: 13px;
  }
`;

const FistBumpContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: ${(props) => (props.isTvMode ? '' : 'pointer')};
  color: ${(props) => (props.isBumped ? '#ff6600' : '')};
  :hover {
    color: ${(props) => (props.isBumped || props.isTvMode ? '' : '#444444')};
  }
`;

const FormWrapper = styled('div')`
  width: 98%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MediaBox = styled('div')`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  padding-left: 0;
  max-height: 300px;
  width: 100%;
  position: relative;
  .reply-media {
    max-height: 300px;
    width: 100%;
    object-fit: cover;
  }
`;

const MediaBoxEdit = styled('div')`
  margin-right: ${({ activeMediaBarOb, comment, uploadMedia }) => (activeMediaBarOb[comment.id] && uploadMedia ? '15px' : '0px')};
  .media-box-div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 0;
    margin-left: 0px;
    left: 0px;
    min-height: 30px;
    min-width: 30px;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-image: url(${({ image }) => image});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border: 0px solid #ced4da;
    border-radius: 50%;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .remove-media {
    display: ${(props) => (props.uploadMedia ? 'flex' : 'none')};
    border-radius: 50%;
    height: 16px;
    width: 16px;
    position: absolute;
    left: 25px;
    z-index: 100;
    top: -5px;
    background: #d6d6d6;
  }
`;

const PostTextContainer = styled('div')`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  .text-area {
    width: 100%;
    white-space: pre-line;
    padding-right: 100px;
    border-radius: 10px;
    padding: 4px 0px;
    border: 1px solid #d9d9d9;
    box-shadow: none;
    outline: none;
  }
`;

const ReplyActionsContainer = styled('div')`
  font-family: 'Nunito Sans', sans-serif;
  display: flex;
  color: #777;
  font-weight: 400;
  font-size: 10px;
  user-select: none;
  padding-top: 5px;
  align-items: center;
  gap: 8px;
`;

const TextActionsContainer = styled('div')`
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  .send-button {
    margin: 0px;
  }
`;

const UserPicDiv = styled('div')`
  position: absolute;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-image: ${(feedObject) => `url(${pictureSelector(feedObject.props.userPic, 70, 70)})`};
  background-size: contain;
  min-width: 40px;
  margin-left: -50px;
  margin-top: 5px;
`;

const VideoIcon = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
  border-radius: 50%;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
`;

const FeedPostCommentReply = ({ reply, feedPost, comment }) => {
  const {
    handleEditFeedPostCommentReply,
    handleDeleteFeedPostCommentReply,
    handleFistBumpReply,
  } = useFeed();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const feed = useSelector((state) => state.feed.data.feed);
  const pinnedFeed = useSelector((state) => state.feed.data.pinnedFeed);
  const uploadMedia = useSelector((state) => state.feed.data.uploadMedia);
  const users = useSelector((state) => state.feed.data.users);
  const activeMediaBarOb = useSelector(
    (state) => state.feed.data.activeMediaBarOb,
  );
  const isTvMode = useSelector((state) => state.feed.data.isTvMode);

  const [isEditing, setIsEditing] = useState(false);
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [userMentions, setUserMentions] = useState([]);
  const [bumpCounter, setBumpCounter] = useState(reply.fistBumps);
  const [isBumped, setIsBumped] = useState(reply.fistBumpActive);
  const [replyText, setReplyText] = useState(reply.postText);

  const dispatch = useDispatch();
  const editFormRef = useRef();

  const mediaBoxStyle = useSpring({
    opacity: uploadMedia ? '1' : '0',
    minWidth: uploadMedia ? '30px' : '0px',
    maxWidth: uploadMedia ? '30px' : '0px',
  });

  useEffect(() => {
    if (editFormRef.current) {
      if (isEditing) {
        editFormRef.current.focus();
      }
    }
  }, [isEditing]);

  useEffect(() => {
    if (isEditing) {
      const mentions = extractMentionsFromText(reply.postText);
      setUserMentions(mentions);
    } else {
      setUserMentions([]);
    }
  }, [isEditing, reply.postText]);

  const handleSetEdit = () => {
    feedTracker('Normal Mode', `Edit reply ${isEditing ? 'canceled' : 'activated'}`);
    if (isEditing) {
      setIsEditing(false);
      setReplyText(reply.postText);
    } else {
      setIsEditing(true);
    }
  };

  useEffect(() => {
    if (isEditing) {
      batch(() => {
        dispatch(setIsReplyActivatedRedux({}));
        if (reply?.media && !!Object.keys(reply.media).length) {
          dispatch(setUploadMedia(reply.media));
          dispatch(setActiveMediaBarOb({ [comment.id]: true }));
        }
      });
    }
  }, [isEditing, reply?.media]);

  const handleDeleteReply = () => {
    const feedObjectIndex = findFeedIndex(feedPost, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedPost);
    const replyObjectIndex = findReplyIndex(reply, comment);
    const { pinned } = feedPost;

    handleDeleteFeedPostCommentReply({
      accountCode: currentUser.accountCode,
      feedIndex: feedObjectIndex,
      feedId: feedPost.id,
      pinned,
      commentIndex: commentObjectIndex,
      commentId: comment.id,
      replyIndex: replyObjectIndex,
      replyId: reply.id,
    });
    feedTracker('Normal Mode', 'Reply deleted');
  };

  const handleReportReply = () => {
    batch(() => {
      dispatch(setActiveReduxModal('report-post-modal'));
      dispatch(setReportPostInfo('Reply', feedPost.id, comment.id, reply.id));
    });
    feedTracker('Normal Mode', 'Report modal opened - reply');
  };

  const submitDisabled = (messageBody) => (!uploadMedia.id && !messageBody?.trim().length)
    || isSubmittingEdit;

  const handleSubmit = () => {
    if (submitDisabled(replyText)) return;
    setIsSubmittingEdit(true);
    const processedText = replyText
      ? replaceMentionsInMessage(replyText, userMentions)
      : '';
    const submissionOb = buildSubmissionObject(processedText, uploadMedia);

    const feedPostIndex = findFeedIndex(feedPost, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedPost);
    const replyObjectIndex = findReplyIndex(reply, comment);

    handleEditFeedPostCommentReply({
      accountCode: currentUser.accountCode,
      submissionOb,
      feedPostIndex,
      feedPostId: feedPost.id,
      commentObjectIndex,
      commentId: comment.id,
      replyObjectIndex,
      replyId: reply.id,
      isPinned: feedPost.pinned,
    });
    feedTracker('Normal Mode', 'Reply edited');
    batch(() => {
      dispatch(setUploadMediaFalse());
      dispatch(setActiveMediaBarOb({}));
    });
    setIsEditing(false);
    // Brief delay to show successful edit feedback to user
    setTimeout(() => {
      setIsSubmittingEdit(false);
    }, 300);
  };

  const handleVideoClick = () => {
    dispatch(openMessageVideo(reply.media.mediaUrl));
    // Replies don't currently support video upload
    // feedTracker('Normal Mode', 'Reply video clicked');
  };

  const handleRemoveMedia = () => {
    dispatch(setUploadMediaFalse());
  };

  const handleMentionsFocus = () => {
    dispatch(setIsReplyActivatedRedux({}));
  };

  const handleMentionsSelect = (selection) => {
    if (selection && selection.value) {
      // Find the user that matches the selected value
      const selectedUser = users.find((user) => `${user.first} ${user.last}` === selection.value);

      if (selectedUser) {
        const submissionValue = `[u=${selectedUser.id}|${selectedUser.first} ${selectedUser.last}]`;
        setUserMentions((prevUserMentions) => [
          ...prevUserMentions,
          submissionValue,
        ]);
      }
    }
  };

  const handleMentionsKeyPress = (e) => {
    const { key, shiftKey } = e;
    if (key === 'Enter' && !shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleMentionsChange = (string) => {
    setReplyText(string);
    filterUserMentions(userMentions, setUserMentions, string);
  };

  const handleSendClick = () => {
    handleSubmit();
  };

  const handleMediaClick = () => {
    if (reply.media.type === 'IMAGE' || reply.media.type === 'EXTERNAL_URL') {
      dispatch(openImageLightbox(reply.media.mediaUrl));
      feedTracker('Normal Mode', 'Reply media clicked');
    }
  };

  const fistBumpReplyOnSuccess = (updatedBumpState, updatedBumpCounter) => {
    setIsBumped(updatedBumpState);
    setBumpCounter(updatedBumpCounter);
  };

  const handleClickFistBump = () => {
    if (isTvMode) {
      return;
    }

    const feedObjectIndex = findFeedIndex(feedPost, feed, pinnedFeed);
    const commentObjectIndex = findCommentIndex(comment, feedPost);
    const replyObjectIndex = findReplyIndex(reply, comment);
    const { pinned } = feedPost;

    handleFistBumpReply({
      accountCode: currentUser.accountCode,
      bool: !reply.fistBumpActive,
      feedPostId: feedPost.id,
      commentId: comment.id,
      replyId: reply.id,
      feedObjectIndex,
      commentObjectIndex,
      replyObjectIndex,
      pinned,
      onSuccess: fistBumpReplyOnSuccess,
    });
    feedTracker('Normal Mode', `Fist bump reply ${!reply.fistBumpActive ? 'activated' : 'deactivated'}`);
  };

  const dropdownEditText = !isEditing ? 'Edit' : 'Cancel Edit';

  const dropdownOptions = () => (
    <FeedDropdownOptions
      contentObject={reply}
      editFunction={handleSetEdit}
      editText={dropdownEditText}
      deleteFunction={handleDeleteReply}
      reportFunction={handleReportReply}
    />
  );

  const renderMediaBoxEdit = () => (comment && activeMediaBarOb[comment.id] && (
    <MediaBoxEdit
      activeMediaBarOb={activeMediaBarOb}
      comment={comment}
      uploadMedia={uploadMedia}
      image={urlSnapper(uploadMedia)}
    >
      <animated.div style={mediaBoxStyle} className='media-box-div'>
        <Button
          icon='remove'
          iconOnly
          size='small'
          variant='secondary'
          visible={uploadMedia}
          onClick={handleRemoveMedia}
          className='remove-media'
        />
      </animated.div>
    </MediaBoxEdit>
  ));

  const renderMentionsInput = () => (
    <Mentions
      validateSearch={createMentionSearchValidator(users)}
      className='text-area'
      placement='bottom'
      value={editMentionText(replyText)}
      onFocus={handleMentionsFocus}
      onSelect={handleMentionsSelect}
      id={reply ? reply.id : ''}
      name='messageBody'
      onKeyDown={handleMentionsKeyPress}
      onChange={handleMentionsChange}
    >
      {users && !!users.length && userParser(users)}
    </Mentions>
  );

  const renderTextActions = () => (
    <TextActionsContainer>
      <FeedGiphyEmoji
        setFieldValue={(field, value) => setReplyText(value)}
        values={{ messageBody: replyText }}
        commentId={comment.id}
        fieldName='messageBody'
      />
      <SendButton
        onClick={handleSendClick}
        disabled={submitDisabled(replyText)}
      />
    </TextActionsContainer>
  );

  const renderEditForm = () => (
    <FormWrapper>
      {renderMediaBoxEdit()}
      <PostTextContainer>
        {renderMentionsInput()}
        {renderTextActions()}
      </PostTextContainer>
    </FormWrapper>
  );

  const renderMediaImage = () => reply.media.mediaUrl && (
    <img
      src={imageFlipper(reply.media)}
      alt='reply-media'
      className='reply-media'
    />
  );

  const renderVideoIcon = () => reply.media.type === 'VIDEO' && (
  <VideoIcon onClick={handleVideoClick}>
    <IcomoonReact iconSet={iconSet} size={50} icon='altrightarrow' />
  </VideoIcon>
  );

  const renderMediaSection = () => {
    if (isEditing || (isSubmittingEdit && !uploadMedia.id) || !reply.media) return null;

    return (
      <MediaBox onClick={handleMediaClick}>
        {renderMediaImage()}
        {renderVideoIcon()}
      </MediaBox>
    );
  };

  const renderFistBumpSection = () => (
    <FistBumpContainer
      isBumped={isBumped}
      isTvMode={isTvMode}
      onClick={handleClickFistBump}
    >
      <div>{bumpCounter === 1 ? 'Fist Bump' : 'Fist Bumps'}</div>
      <div>
        (
        {bumpCounter}
        )
      </div>
    </FistBumpContainer>
  );

  const renderReplyActions = () => (
    <ReplyActionsContainer>
      {renderFistBumpSection()}
      <div>{dateCreator(reply.createdAt)}</div>
    </ReplyActionsContainer>
  );

  return (
    <FeedPostCommentReplyDiv>
      <UserPicDiv props={reply} />
      {!isTvMode && <DropdownDiv>{dropdownOptions()}</DropdownDiv>}
      <FeedPostReplyContent isBumped={isBumped} isTvMode={isTvMode}>
        <div className='reply-author'>{reply.userName}</div>
        <div className='reply-body'>
          {!isEditing
            ? reply.postText
              ? transformPostText(reply.postText, true)
              : ''
            : renderEditForm()}
        </div>
        {renderMediaSection()}
        {renderReplyActions()}
      </FeedPostReplyContent>
    </FeedPostCommentReplyDiv>
  );
};

FeedPostCommentReply.propTypes = {
  reply: PropTypes.instanceOf(Object).isRequired,
  feedPost: PropTypes.instanceOf(Object).isRequired,
  comment: PropTypes.instanceOf(Object).isRequired,
};

export default FeedPostCommentReply;
